export default {
      id: "shield-done-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "img/icons.svg#shield-done",
      toString: function () {
        return this.url;
      }
    }